import { render, staticRenderFns } from "./PgaApproveButton.vue?vue&type=template&id=edc2099a&"
import script from "./PgaApproveButton.vue?vue&type=script&lang=ts&"
export * from "./PgaApproveButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc2099a')) {
      api.createRecord('edc2099a', component.options)
    } else {
      api.reload('edc2099a', component.options)
    }
    module.hot.accept("./PgaApproveButton.vue?vue&type=template&id=edc2099a&", function () {
      api.rerender('edc2099a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PgaApproveButton.vue"
export default component.exports